import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Confidencialidad from '../images/confidencialidad.svg';
import Eficiencia from '../images/eficiencia.svg';
import Cliente from '../images/cliente.svg';
import Vision from '../images/vision.svg';
import '../styles/ServicePage.css';
import '../styles/CustomSlider.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

const slides = [
    { title: "Gestiona y organiza con facilidad todos tus casos", color: "rgba(10, 35, 66)" },
    { title: "Informa y reporta eficientemente a tus clientes", color: "rgba(10, 35, 66)" },
    { title: "Analiza y usa datos para la toma de decisiones", color: "rgba(10, 35, 66)" },
    { title: "Transiciona tu gestión legal al futuro con legabot ", color: "rgba(10, 35, 66)" },
    { title: "Automatiza tareas administrativas y asistencia de IA para casos legales", color: "rgba(10, 35, 66)" },
];

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    centerMode: true,
    centerPadding: '25%',
    focusOnSelect: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                centerPadding: '20px',
            },
        },
    ],
};


export function ServicePage() {
    return (
        <Box className="box-service">
            <Grid container spacin g={2}>

                <Grid size={12} className="section-service">
                    { /*<div className="overlay"></div>*/}
                    <Grid size={12} className="section1-service">
                        <h1
                        >TODOS TUS CASOS EN EL MISMO LUGAR</h1>
                        <p>Legabot para despachos jurídicos</p>
                    </Grid>
                </Grid>

<Grid size={12} className="section3-servicios">
                       <p>BENEFICIOS</p>
                </Grid>

                               <div style={{
                    padding: "40px 0",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: '600px'
                }}>
                    <div style={{
                        width: '100%'
                    }}>
                        <Slider {...settings}>
                            {slides.map((slide, index) => (
                                <div key={index}>
                                    <div style={{
                                        height: '400px',
                                        margin: '0 10px',
                                        borderRadius: '15px',
                                        background: slide.color,
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '20px'
                                    }}>
                                        <h1 style={{
                                            color: 'white',
                                            fontSize: '60px',
                                            fontWeight: '300',
                                            textAlign: 'center',
                                            margin: 0,
                                            lineHeight: '1.3',
                                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                        }}>{slide.title}</h1>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>




                <Grid size={12} className="section-info-service" mt={5}>
                    <div className="overlay2"></div>
                    <Grid size={12} className="section4-info-service">
                        <p>Transiciona hacia lo digital con confianza.</p>
                        <button className="button-propuesta-service">Solicitar demo</button>
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    );
}

